import axios from "axios";
import { BASE_URL, getAuthorizationHeader } from "../const";

const TRIP_ENDPOINT = {
  TRIP_FILTER_URL: BASE_URL + "trip/filter?type=",
  CREATE_TRIP_URL: BASE_URL + "trip/",
  ENROLL_TRIP: BASE_URL + "trip/",
  PARTICIPANTS_LIST: BASE_URL + "trip/participant/",
  UPDATE_TRIP_URL: BASE_URL + "trip/",
  DELETE_TRIP_URL: BASE_URL + "trip/",
};

export const GetFilterTripAPI = async (
  type,
  search,
  isPublic,
  minPrice,
  maxPrice,
  month,
  minDuration,
  maxDuration,
  themes,
  age
) => {
  let url = `${TRIP_ENDPOINT.TRIP_FILTER_URL}${type}`;
  if (search) {
    url += `&search=${search}`;
  }
  if (isPublic) {
    url += `&isPublic=${isPublic}`;
  }
  if (minPrice) {
    url += `&minPrice=${minPrice}`;
  }
  if (maxPrice) {
    url += `&maxPrice=${maxPrice}`;
  }
  if (month) {
    url += `&tripMonth=${month}`;
  }
  if (minDuration) {
    url += `&minDuration=${minDuration}`;
  }
  if (maxDuration) {
    url += `&maxDuration=${maxDuration}`;
  }
  if (themes) {
    url += `&themes=${themes}`;
  }
  if (age) {
    url += `&age=${age}`;
  }
  return axios.get(url);
};

export const CreateTripAPI = async (payload) => {
  let headers = await getAuthorizationHeader();
  if (headers) {
    return axios.post(TRIP_ENDPOINT.CREATE_TRIP_URL, payload, headers);
  }
};
export const UpdateTripAPI = async (trip_id, payload) => {
  let headers = await getAuthorizationHeader();
  if (headers) {
    return axios.patch(
      TRIP_ENDPOINT.UPDATE_TRIP_URL + trip_id + "/",
      payload,
      headers
    );
  }
};

export const EnrollTrip = async (id, payload) => {
  let headers = await getAuthorizationHeader();
  if (headers) {
    return axios.post(
      `${TRIP_ENDPOINT.ENROLL_TRIP}${id}/enroll/`,
      payload,
      headers
    );
  }
};

export const EnrollTripWithoutLogin = async (id, payload) => {
  return axios.post(
    `${TRIP_ENDPOINT.ENROLL_TRIP}${id}/enroll/public/`,
    payload
  );
};

export const GetTripParticipants = async (id) => {
  let headers = await getAuthorizationHeader();
  if (headers) {
    return axios.get(`${TRIP_ENDPOINT.PARTICIPANTS_LIST}${id}/`, headers);
  }
};

export const DeleteTripAPI = async (id) => {
  let headers = await getAuthorizationHeader();
  if (headers) {
    return axios.delete(`${TRIP_ENDPOINT.DELETE_TRIP_URL}${id}/`, headers);
  }
};
